// import { useEffect, useState } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
// import { useInView } from "react-intersection-observer";
import Marketplace from "../../images/Marketplace.svg";
import MarketplaceMobile from "../../images/MarketplaceMobile.svg";
import MarketplaceGrowth from "../../images/MarketplaceGrowth.svg";
import {
  motion,
  // useScroll,
  // useTransform,
  useAnimation,
} from "framer-motion/dist/framer-motion";
import { useRef, useState, useEffect } from "react";
import Sales from "../../images/Sales.svg";
import Income from "../../images/Income.svg";
import { useInView } from "react-intersection-observer";

const marketplaceVariants = {
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.5, ease: "linear", delay: 0.2 },
  },
  hidden: {
    opacity: 0,
    y: "-30vh",
    scale: 0.5,
    transition: { duration: 0.5, ease: "linear", delay: 0.2 },
  },
};

const MarketplaceRow = () => {
  const ref = useRef(null);

  // const { scrollYProgress } = useScroll({
  //   target: ref,
  //   offset: ["start end", "end end"],
  // });

  // const MPTX = useTransform(
  //   scrollYProgress,
  //   // Map x from these values:
  //   [0, 1],
  //   // Into these values:
  //   [0, -420],
  //   { clamp: false }
  // );

  const controls = useAnimation();
  const [viewRef, inView] = useInView();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (inView && !shown) {
      controls.start("visible");
      setShown(true);
    } else if (!inView && shown) {
      controls.start("hidden");
      setShown(false);
    } else {
      controls.start("hidden");
      setShown(false);
    }
    // eslint-disable-next-line
  }, [controls, inView]);

  return (
    <div className="color-dk-r">
      <div className="row m-0 flex-row-reverse">
        <div className="stickyRowHeaders col-lg-4 col-12 d-flex align-items-center justify-content-center  bg-color-gr text-center">
          <div className="d-lg-none d-inline">
            <div>Marketplace</div>
          </div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-140, 140]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                <div>Marketplace</div>
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>

        <div className="col-lg-8 col-12 text-start color-dk-dark line-height-lg px-0 bg-color-w pt-5">
          <div className="row mx-0">
            <div className="d-none d-lg-block text-center d-flex justify-content-center mx-auto  my-5">
              <img className="mx-3" src={Marketplace} alt="Marketplace" />
            </div>
            <div className="d-block d-lg-none text-center d-flex justify-content-center mx-auto my-2">
              <img
                style={{ maxWidth: "350px" }}
                className
                src={MarketplaceMobile}
                alt="Marketplace"
              />
            </div>
          </div>

          <motion.div
            animate={controls}
            initial="hidden"
            variants={marketplaceVariants}
            ref={viewRef}
            className="row mx-0 align-items-center pb-5 px-3 px-lg-5 my-lg-5"
          >
            <div
              ref={ref}
              className="d-flex justify-content-center  my-1 col-12 col-lg-6"
            >
              <img
                style={{ height: 350 }}
                src={MarketplaceGrowth}
                alt="Marketplace Growth"
              />
            </div>
            <div className="col-12 col-lg-6">
              <div className="row align-items-center mx-0 mt-5 mb-3">
                <div
                  className="col-3 bg-dk-gr p-3 p-lg-4 my-3"
                  style={{ borderRadius: "10px" }}
                >
                  <img src={Income} alt="Marketplace Income" />
                </div>
                <div className="col-9">
                  <h6>
                    <span
                      className="color-dk-r"
                      style={{ fontSize: "26px", fontWeight: "800" }}
                    >
                      494{" "}
                    </span>
                    <span style={{ fontSize: "18px", fontWeight: "600" }}>
                      Million Rials
                    </span>
                  </h6>
                  <p style={{ fontSize: "14px" }}>
                    In 2021-22, each marketplace seler made an average monthly
                    income of IRR 494 million.
                  </p>
                </div>
                <div
                  className="col-3 bg-dk-gr p-3 p-lg-4 my-3"
                  style={{ borderRadius: "10px" }}
                >
                  <img src={Sales} alt="Marketplace Sales" />
                </div>
                <div className="col-9">
                  <h6>
                    <span
                      className="color-dk-r"
                      style={{ fontSize: "26px", fontWeight: "800" }}
                    >
                      467{" "}
                    </span>
                    <span style={{ fontSize: "18px", fontWeight: "600" }}>
                      Billion Rials
                    </span>
                  </h6>
                  <p style={{ fontSize: "14px" }}>
                    In 2021-22, a seller set a monthly sales record worth IRR
                    467 biollion.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default MarketplaceRow;
